const filters = (state = [], action) => {
    switch (action.type) {
      case 'START_FILTERS':
        return {
            type: "START_FILTERS",
            ...state,
            fila_checkbox_callback: action.callback,
            fila_checkbox_espera: action.fila,
            fila_checkbox_em_tratamento: action.tratamento,
            fila_checkbox_retorno: action.retorno,
            array_fila: action.array
        }
      case 'FILTRO_CALLBACK':
        return {
          type: "FILTRO_CALLBACK",
          ...state,
          fila_checkbox_callback: action.post,
        }
      case 'FILTRO_FILA':
        return {
            type: "FILTRO_FILA",
            ...state,
            fila_checkbox_espera: action.post
        }
      case 'FILTRO_TRATAMENTO':
        return {
            type: "FILTRO_TRATAMENTO",
            ...state,
            fila_checkbox_em_tratamento: action.post
        }
      case 'FILTRO_RETORNO':
        return {
            type: "FILTRO_RETORNO",
            ...state,
            fila_checkbox_retorno: action.post
        }
      case 'ARRAY_FILA':
        return {
            type: "ARRAY_FILA",
            ...state,
            array_fila: action.post
        }
      default:
      return state
    }
  }
  
  export default filters